import baseUrl from './baseUrl';

const URL_CRIAR_USUARIO = `${baseUrl}/auth/register`;

const criarUsuario = async data => {
  try {
    const response = await fetch(URL_CRIAR_USUARIO, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }
  } catch (error) {
    console.log(error);
  }
};

export default criarUsuario;
